export default {
  FETCH_STYLE: 'catalog/FETCH_CATALOG',
  STYLE_LOADED: 'catalog/STYLE_LOADED',
  STYLE_LOAD_ERROR: 'catalog/STYLE_LOAD_ERROR',
  FETCH_STYLES: 'catalog/FETCH_CATALOGS',
  SET_OVERLAY_STYLES: 'catalog/SET_OVERLAY_STYLES',
  STYLES_SUCCESS: 'catalog/STYLES_SUCCESS',
  STYLES_ERROR: 'catalog/STYLES_ERROR',
  LOAD_CATALOG_DESIGN: 'catalog/LOAD_CATALOG_DESIGN'
};
